export const environment = {
  production: true,
  apiBaseUrl: 'https://api.academy.localhost.smosc.com.br:10041',
  syncfusionLicenseKey: '',
  smocipaApiBaseUrl: 'https://api.cipa.smosc.com.br',
};